import "./pageWrapper.scss";
import React, { forwardRef } from "react";
import { VeBox, VeTypography } from "../../mui";

interface PageWrapperOptions {
  leftNode?: JSX.Element | boolean;
  rightNode?: JSX.Element | boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  border?: boolean;
  noPadding?: boolean;
  userWrapper?: boolean;
  title?: string;
  titleVariant?: any;
  aboveTitle?: any;
  rightNodeToTitle?: JSX.Element;
  showTotalCount?: boolean;
  totalCount?: number; // to display total count to side of title
}

export const PageWrapper = forwardRef<HTMLDivElement, PageWrapperOptions>(
  (
    {
      children,
      leftNode,
      rightNode,
      style,
      border,
      noPadding,
      userWrapper,
      title,
      aboveTitle,
      rightNodeToTitle,
      showTotalCount = false,
      totalCount,
      titleVariant = "title3Main",
    },
    ref
  ) => {
    const padding = noPadding ? 0 : undefined;
    return (
      <VeBox
        className={
          border
            ? "mainWrapperBorder"
            : userWrapper
              ? "mainWrapperUser"
              : "mainWrapper"
        }
        sx={{ padding: `${padding} !important`, ...style }}
        ref={ref}
      >
        {aboveTitle && <VeBox>{aboveTitle}</VeBox>}
        {title && (
          <VeBox
            display="flex"
            alignItems="center"
            justifyContent={rightNodeToTitle ? "space-between" : undefined}
          >
            <VeBox
              display="flex"
              alignItems={"center"}
              flexDirection={"row"}
              gap="4px"
            >
              <VeTypography variant={titleVariant}> {title}</VeTypography>
              {showTotalCount && (
                <VeTypography variant={"label2StrongTertiary"}>
                  {`(${totalCount} items)`}
                </VeTypography>
              )}
            </VeBox>
            {rightNodeToTitle && rightNodeToTitle}
          </VeBox>
        )}
        {(leftNode || rightNode) && (
          <VeBox className="wrapperElements">
            {leftNode ? leftNode : <VeBox></VeBox>}
            {rightNode ? rightNode : <VeBox></VeBox>}
          </VeBox>
        )}
        {children && <VeBox id="pageScroll">{children}</VeBox>}
      </VeBox>
    );
  }
);
